import { NetworkEnums } from '../../../../shared/GameEnums.ts';
const State = NetworkEnums.State;
import { cloneDeep } from 'lodash-es';
const LATENCY_LOW_MS = 500;
const LATENCY_MEDIUM_MS = 1500;
const LATENCY_HIGH_MS = 5000;
const PING_INTERVAL_MS = 1000;
export class SocketMonitor {
    activate() {
        if (this.active) return;
        this.active = true;
        this.startMonitoringLatency();
    }
    startMonitoringLatency() {
        if (!this.active) return;
        if (this.timer != undefined) this.stats.reconnects += 1;
        this.stopMonitoringLatency();
        this.timer = setInterval(()=>this.sendPing(), PING_INTERVAL_MS);
    }
    sendPing() {
        const ts = Date.now();
        this.pingTimestamps.add(ts);
        this.controller.sender.sendPing(ts);
    }
    stopMonitoringLatency() {
        clearInterval(this.timer);
        this.pingTimestamps.clear();
    }
    handlePong(data) {
        var _this_stats_buckets, _latencyBucket;
        const pongTimestamp = Date.now();
        const pingTimestamp = data.timestamp;
        if (!this.pingTimestamps.has(pingTimestamp)) return;
        const latency = Math.round((pongTimestamp - pingTimestamp) / 2);
        this.lastLatency = latency;
        const latencyBucket = getLatencyBucket(latency);
        var _;
        (_ = (_this_stats_buckets = this.stats.buckets)[_latencyBucket = latencyBucket]) !== null && _ !== void 0 ? _ : _this_stats_buckets[_latencyBucket] = 0;
        this.stats.buckets[latencyBucket] += 1;
        if (latency <= LATENCY_LOW_MS) {
            this.stats.low += 1;
        } else if (latency <= LATENCY_MEDIUM_MS) {
            this.stats.medium += 1;
        } else if (latency <= LATENCY_HIGH_MS) {
            this.stats.high += 1;
        } else {
            this.stats.dropped += 1;
        }
        this.pingTimestamps.delete(pingTimestamp);
    }
    getFinalStats() {
        const stats = cloneDeep(this.stats);
        for (const pingTimestamp of this.pingTimestamps){
            var _stats_buckets, _latencyBucket;
            const latencyBucket = getLatencyBucket(Date.now() - pingTimestamp);
            var _;
            (_ = (_stats_buckets = stats.buckets)[_latencyBucket = latencyBucket]) !== null && _ !== void 0 ? _ : _stats_buckets[_latencyBucket] = 0;
            stats.buckets[latencyBucket] += 1;
        }
        return stats;
    }
    constructor(controller){
        this.pingTimestamps = new Set();
        this.lastLatency = 0;
        this.active = false;
        this.controller = controller;
        this.stats = {
            reconnects: 0,
            low: 0,
            medium: 0,
            high: 0,
            dropped: 0,
            buckets: {}
        };
        this.controller.registerSessionEstablishedObserver(()=>this.startMonitoringLatency());
        this.controller.registerSocketCloseObserver(()=>this.stopMonitoringLatency());
        this.controller.setStateHandler(State.SocketMonitorUpdate, (data)=>this.handlePong(data));
    }
}
function getLatencyBucket(latency) {
    const size = 100;
    return Math.round(latency / size) * size;
}
